<template>
  <div>
    <Row type="flex" justify="start" ref="cardgroup" class="cardgroup">
      <Col v-for="(item,index) in userList" :key="index" :style="{'margin-left':marginLeft}">
        <dragger :drag-target="item" :drag-data="item.unionId">
          <Card class="icard" :padding="0">
            <div
              class="card-wrapper"
              @click="cardClick(index)"
              @mouseover="cardHover(index)"
              @mouseout="cardOut(index)"
            >
              <!-- 左上角多选框 -->
              <div
                class="iconfont icon-checkbox"
                :class="[item.clickCheck?'icon-duoxuan1':'icon-duoxuankuang1']"
                @click.stop="clickCheck(item,index)"
              ></div>
              <!-- 右上角叉叉 -->
              <div
                class="iconfont icon-chushaixuanxiang icon-cha"
                v-show="item.showCha"
                @click.stop="clickCha(item,index)"
              ></div>
              <!-- 卡片上 -->
              <div class="card-top">
                <img class="headpic" :src="item.headPicUrl||require('@/assets/images/default.png')" />
                <!-- 左侧标签 -->
                <div
                  class="authstate"
                  :class="authClass(item.authState)"
                >{{item.authState==1?'已实名':(item.authState==0?'未认证':'待审核')}}</div>
                <div class="ptype">{{item.name}}</div>
                <div class="pname">
                  <span class="iconfont icon-dangyuan" v-if="item.isParty"></span>
                  {{item.realName||'暂无姓名'}}
                </div>
              </div>
              <!-- 卡片下 -->
              <div class="from-wrapper">
                <!-- 居民页用 以下 -->
                <div class="from" v-show="item.org">
                  <span class="iconfont icon-dangzhibugongzuo icon"></span>
                  <span>{{item.org&&item.org.zoneName}}</span>
                </div>
                <div class="from" v-show="item.community">
                  <span class="iconfont icon-shequ icon"></span>
                  <span>{{item.community&&item.community.zoneName}}</span>
                </div>
                <div class="from" v-show="item.shequ">
                  <span class="iconfont icon-shequ icon"></span>
                  <span>{{item.shequ&&item.shequ.zoneName}}</span>
                </div>
                <!-- 社工页用 -->
                <div class="from" v-show="item.companyOrCommunityName">
                  <span class="iconfont icon-shequ icon"></span>
                  <span>{{item.companyOrCommunityName}}</span>
                </div>
              </div>
            </div>
          </Card>
        </dragger>
      </Col>
    </Row>
  </div>
</template>

<script>
import dragger from "../../../components/dragger/drag";
var that;
export default {
  name: "sqfwCard",
  components: {
    dragger
  },
  props: ["userList", "newcheckList"],
  data() {
    return {
      dragstart: false,
      cardItemWidth: 280, // 设为0 可动态获取 宽度
      marginLeft: "",
      isShowDelete: false,
      deleteUnionid: "",
      checkList: []
    };
  },
  methods: {
    /* 点击 */
    cardClick(index) {
      this.$emit("cardClick", this.userList[index]);
    },
    cardHover(index) {
      this.userList[index].showCha = true;
    },
    cardOut(index) {
      this.userList[index].showCha = false;
    },
    clickCha(item, index) {
      this.$emit("delPeople", {
        unionId: item.unionId,
        communityId: item.communityId
      });
    },
    clickCheck(item, index) {
      item.clickCheck = !item.clickCheck;
      if (this.checkList.indexOf(item) == -1) {
        this.checkList.push(item);
      } else {
        this.checkList.splice(this.checkList.indexOf(item), 1);
      }
      this.$emit("checkList", this.checkList);
    },
    authClass: function(state) {
      return {
        verified: state == 1,
        verifying: state == -1,
        noVerify: state == 0
      };
    },
    getMargin() {
      this.$nextTick()
        .then(() => {
          if (this.$refs.cardgroup) {
            let boxWidth = this.$refs.cardgroup.$el.clientWidth;
            let count = Math.floor(boxWidth / this.cardItemWidth) + 1;
            let rest = boxWidth % this.cardItemWidth;
            this.marginLeft = rest / count + "px";
          }
        })
        .catch(e => console.log(e));
    }
  },
  watch: {
    userList: function() {
      //  没有初始化时执行
      if (!this.cardItemWidth) {
        // 有数据时执行
        if (this.$refs.cardgroup.$children.length > 0) {
          this.cardItemWidth = this.$refs.cardgroup.$children[0].$el.clientWidth;
          this.getMargin();
        }
      }
    }
  },
  created() {
    that = this;
  },
  mounted() {
    this.getMargin();
    window.onresize = this.getMargin;
    try {
      this.checkList = JSON.parse(JSON.stringify(this.newcheckList));
    } catch (error) {}
  }
};
</script>

<style scoped lang="less">
.card-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 278px;
  height: 356px;
  border-radius: 6px;
}
.authstate {
  position: absolute;
  left: 100px;
  top: 115px;
  width: 82px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 15px;
  color: #fff;
}
.icard {
  margin-bottom: 30px;
  border-radius: 6px;
}
.card-top {
  height: 244px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #eee;
}
.headpic {
  display: inline-block;
  width: 100px;
  height: 100px;
  border-radius: 100%;
  // box-shadow: 2px 2px 4px 1px #898989;
  // 处理 图片加载失败的hack
  overflow: hidden;
  &::before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
  }
}
.ptype {
  margin-top: 28px;
  font-size: 18px;
  font-weight: 600;
  color: #4b4b4b;
}
.pname {
  text-align: center;
  font-size: 16px;
  color: #999;
  margin-top: 10px;
  .icon-dangyuan {
    color: #e40203;
  }
}
.from-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
}
.from {
  text-align: center;
  padding-bottom: 5px;
}

.icon {
  padding-right: 5px;
  color: #cdcdcd;
}
.icon-cha {
  position: absolute;
  right: 20px;
  top: 20px;
  color: #cdcdcd;
  font-size: 20px;
}
.icon-checkbox {
  position: absolute;
  top: 20px;
  left: 20px;
  color: #cdcdcd;
  font-size: 20px;
}
.icon-duoxuan1 {
  color: #d22c2b;
}
.icon-dangzhibugongzuo {
  color: #fe583e;
}
/* 认证状态 */
.verified {
  background-color: #47ba54;
}
.verifying {
  background-color: #ff7744;
}
.noVerify {
  background-color: #a1afb3;
}
</style>
